import styled from 'styled-components'

const ItemTitle = styled.div``

export default ItemTitle